/**
 * Suscriptores
 */
const subscribers = [
    {
        subscriber: 'Desarrollo',
        domain: 'http://localhost:8080',
        api_domain: 'http://localhost:8085',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://192.168.20.51:8080',
        api_domain: 'http://192.168.20.51:8085',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://192.168.1.15:8080',
        api_domain: 'http://192.168.1.15:8085',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://127.0.0.1:8080',
        api_domain: 'http://127.0.0.1:8085',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://localhost:8081',
        api_domain: 'http://localhost:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://127.0.0.1:8081',
        api_domain: 'http://127.0.0.1:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://localhost:8081',
        api_domain: 'http://localhost:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://127.0.0.1:8081',
        api_domain: 'http://127.0.0.1:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900338016',
        subscriber: 'Colsaisa2',
        domain: 'https://colsaisa2.starcommerce.co',
        api_domain: 'https://apicolsaisa2.starcommerce.co',
        logo: '/static/subscribers_logos/colsaisa2.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900338016',
        subscriber: 'Pruebas Colsaisa2',
        domain: 'https://colsaisa2pruebas.starcommerce.co',
        api_domain: 'https://apicolsaisa2pruebas.starcommerce.co',
        logo: '/static/subscribers_logos/colsaisa2.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '830048991',
        subscriber: 'Colrecambios',
        domain: 'https://colrecambios.starcommerce.co',
        api_domain: 'https://apicolrecambios.starcommerce.co',
        logo: '/static/subscribers_logos/colrecambios.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '830048991',
        subscriber: 'Colrecambios Pruebas',
        domain: 'https://colrecambiospruebas.starcommerce.co',
        api_domain: 'https://apicolrecambiospruebas.starcommerce.co',
        logo: '/static/subscribers_logos/colrecambios.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900710720',
        subscriber: 'Xinetix',
        domain: 'https://xinetix.starcommerce.co',
        api_domain: 'https://apixinetix.starcommerce.co',
        logo: '/static/subscribers_logos/xinetix.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900710720',
        subscriber: 'Xinetix Pruebas',
        domain: 'https://xinetixpruebas.starcommerce.co',
        api_domain: 'https://apixinetixpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/xinetix.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900266427',
        subscriber: 'Lugor',
        domain: 'https://lugor.starcommerce.co',
        api_domain: 'https://apilugor.starcommerce.co',
        logo: '/static/subscribers_logos/lugor.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900266427',
        subscriber: 'Lugor Pruebas',
        domain: 'https://lugorpruebas.starcommerce.co',
        api_domain: 'https://apilugorpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/lugor.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '800249945',
        subscriber: 'Hys',
        domain: 'https://hys.starcommerce.co',
        api_domain: 'https://apihys.starcommerce.co',
        logo: '/static/subscribers_logos/hys.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '800249945',
        subscriber: 'Hys Pruebas',
        domain: 'https://hyspruebas.starcommerce.co',
        api_domain: 'https://apihyspruebas.starcommerce.co',
        logo: '/static/subscribers_logos/hys.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '860402526',
        subscriber: 'La Rueda',
        domain: 'https://larueda.starcommerce.co',
        api_domain: 'https://apilarueda.starcommerce.co',
        logo: '/static/subscribers_logos/larueda.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',

    },
    {
        identification: '860402526',
        subscriber: 'La Rueda Pruebas',
        domain: 'https://laruedapruebas.starcommerce.co',
        api_domain: 'https://apilaruedapruebas.starcommerce.co',
        logo: '/static/subscribers_logos/larueda.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '901666689',
        subscriber: 'VW',
        domain: 'https://vw.starcommerce.co',
        api_domain: 'https://apivw.starcommerce.co',
        logo: '/static/subscribers_logos/vw.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '901666689',
        subscriber: 'VW Pruebas',
        domain: 'https://vwpruebas.starcommerce.co',
        api_domain: 'https://apivwpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/vw.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900245118',
        subscriber: 'Menu3',
        domain: 'https://menu3.starcommerce.co',
        api_domain: 'https://apimenu3.starcommerce.co',
        logo: '/static/subscribers_logos/menu3.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900245118',
        subscriber: 'Menu3 Pruebas',
        domain: 'https://menu3pruebas.starcommerce.co',
        api_domain: 'https://apimenu3pruebas.starcommerce.co',
        logo: '/static/subscribers_logos/menu3.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '800198348',
        subscriber: 'Ventas Institucionales',
        domain: 'https://ventasinstitucionales.starcommerce.co',
        api_domain: 'https://apiventasinstitucionales.starcommerce.co',
        logo: '/static/subscribers_logos/ventasinstitucionales.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '800198348',
        subscriber: 'Ventas Institucionales Pruebas',
        domain: 'https://ventasinstitucionalespruebas.starcommerce.co',
        api_domain: 'https://apiventasinstitucionalespruebas.starcommerce.co',
        logo: '/static/subscribers_logos/ventasinstitucionales.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '830508200',
        subscriber: 'Isla',
        domain: 'https://isla.starcommerce.co',
        api_domain: 'https://apiisla.starcommerce.co',
        logo: '/static/subscribers_logos/isla.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '830508200',
        subscriber: 'Isla Pruebas',
        domain: 'https://islapruebas.starcommerce.co',
        api_domain: 'https://apiislapruebas.starcommerce.co',
        logo: '/static/subscribers_logos/isla.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900646266',
        subscriber: 'U2',
        domain: 'https://u2.starcommerce.co',
        api_domain: 'https://apiu2.starcommerce.co',
        logo: '/static/subscribers_logos/u2.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900646266',
        subscriber: 'U2 Pruebas',
        domain: 'https://u2pruebas.starcommerce.co',
        api_domain: 'https://apiu2pruebas.starcommerce.co',
        logo: '/static/subscribers_logos/u2.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900973544',
        subscriber: 'Batericars',
        domain: 'https://batericars.starcommerce.co',
        api_domain: 'https://apibatericars.starcommerce.co',
        logo: '/static/subscribers_logos/batericars.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900973544',
        subscriber: 'Batericars Pruebas',
        domain: 'https://batericarspruebas.starcommerce.co',
        api_domain: 'https://apibatericarspruebas.starcommerce.co',
        logo: '/static/subscribers_logos/batericars.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900598368',
        subscriber: 'Sager',
        domain: 'https://sager.starcommerce.co',
        api_domain: 'https://apisager.starcommerce.co',
        logo: '/static/subscribers_logos/sager.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900598368',
        subscriber: 'Sager Pruebas',
        domain: 'https://sagerpruebas.starcommerce.co',
        api_domain: 'https://apisagerpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/sager.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '11111',
        subscriber: 'Energy',
        domain: 'https://energy.starcommerce.co',
        api_domain: 'https://apienergy.starcommerce.co',
        logo: '/static/subscribers_logos/energy.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '11111',
        subscriber: 'Energy Pruebas',
        domain: 'https://energypruebas.starcommerce.co',
        api_domain: 'https://apienergypruebas.starcommerce.co',
        logo: '/static/subscribers_logos/energy.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '902048314',
        subscriber: 'EuroMotor',
        domain: 'https://euromotor.starcommerce.co',
        api_domain: 'https://apieuromotor.starcommerce.co',
        logo: '/static/subscribers_logos/euromotor.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '902048314',
        subscriber: 'EuroMotor Pruebas',
        domain: 'https://euromotorpruebas.starcommerce.co',
        api_domain: 'https://apieuromotorpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/euromotor.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '800023543',
        subscriber: 'Aceitar',
        domain: 'https://aceitar.starcommerce.co',
        api_domain: 'https://apiaceitar.starcommerce.co',
        logo: '/static/subscribers_logos/aceitar.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '800023543',
        subscriber: 'Aceitar Pruebas',
        domain: 'https://aceitarpruebas.starcommerce.co',
        api_domain: 'https://apiaceitarpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/aceitar.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900338016',
        subscriber: 'colsaisa',
        domain: 'https://colsaisa.starcommerce.co',
        api_domain: 'https://apicolsaisa.starcommerce.co',
        logo: '/static/subscribers_logos/colsaisa.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900338016',
        subscriber: 'colsaisa Pruebas',
        domain: 'https://colsaisapruebas.starcommerce.co',
        api_domain: 'https://apicolsaisapruebas.starcommerce.co',
        logo: '/static/subscribers_logos/colsaisa.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
];

/**
 * Obtener el suscriptor
 * @returns Object Contiene la información del suscriptor
 * @author Jhon García
 */
export function getSubscriber() {
    const domain = document.location.origin;

    return subscribers.find(subscriber => subscriber.domain === domain);
}


/**
 * Obtener el suscriptor por número de identificación.
 * @returns Object Contiene la información del suscriptor
 * @author Jhon García
 */
export function getSubscriberByIdentification() {
    let subscriber = localStorage.getItem('subscriber');

    if (subscriber) {
        subscriber = JSON.parse(subscriber);
        return subscribers.find(s => s.identification === subscriber.identification);
    }

    return getSubscriber();
}

/**
 * Obtener el dominio actual
 * @returns {*} Contiene el dominio actual
 * @author Jhon García
 */
export function getDomain() {
    return document.location.origin;
}

/**
 * Determinar el dominio del api, de acuerdo al dominio del front
 * @returns {string|null} Contiene el dominio del api o null si no existe
 * @author Jhon García
 */
export function getApiDomain() {
    let subscriber = getSubscriber();

    if (subscriber) {
        return subscriber.api_domain;
    }

    return null;
}

/**
 * Resuelve una URL de imagen: si ya es absoluta (S3, CDN, etc.) la retorna tal cual;
 * si es relativa, le antepone el dominio del API.
 * @param {string} path
 * @returns {string}
 */
export function resolveImageUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const encoded = encodeURI(path).replace(/#/g, '%23');
    return (getApiDomain() || '') + encoded;
}

/**
 * Determinar el dominio del api, de acuerdo al dominio del front
 * @returns {string|null} Contiene el dominio del api o null si no existe
 * @author Jhon García
 */
export function getLogoSubscriber() {
    let subscriber = getSubscriber();

    if (subscriber) {
        return subscriber.logo;
    }

    return null;
}

export function getIdentificationSubscriber() {
    let subscriber = getSubscriber();

    if (subscriber) {
        return subscriber.identification;
    }

    return null;
}



// WEBPACK FOOTER //
// ./src/util/domains.js